module.exports = __webpack_public_path__ + "img/1f3d0.be3e65e.svg";